import "@amap/amap-jsapi-types";
import {IOverlayDelete, IResult, IRouteParameter} from "@/types/map";
import axios from "axios";
import OverlayPGIS from "../../Overlays/pgis/OverlayPGIS";
import {param} from "jquery";

declare let BMap: any;
export default class RoutePGIS {
  private static intances: Map<string, any>;
  private view!: any;
  private fmap!: any;
  private constructor(view: any, fmap: any) {
    this.view = view;
    this.fmap = fmap;
  }

  public static getInstance(view: any, fmap: any) {
    let id = view.getTarget();
    if (!RoutePGIS.intances) {
      RoutePGIS.intances = new Map();
    }
    let intance = RoutePGIS.intances.get(id);
    if (!intance) {
      intance = new RoutePGIS(view, fmap);
      RoutePGIS.intances.set(id, intance);
    }
    return intance;
  }
  public static destroy() {}
  public async clearRouteSearch(params?: IOverlayDelete) {
    let overlay = OverlayPGIS.getInstance(this.view, this.fmap);
    if (params === undefined) {
      overlay.deleteOverlays({types: ["routesearchPgis"]});
    } else {
      let ids = params.ids;
      overlay.deleteOverlays({ids: ids});
    }
  }
  public async routeSearch(params: IRouteParameter): Promise<IResult> {
    const destination = params.end as number[];
    const origin = params.start as number[];
    const midPoints = params.waypoints as number[][];
    const showLine = params.showLine !== false;
    const lineColor = params.lineColor || "#0088cc";
    const lineWidth = params.lineWidth || 2;
    const paths = params.paths;

    const id = params.id || "onlyRoute";
    this.clearRouteSearch({ids: [id]});
    if (paths) {
      await this.showRouteLine(
        id,
        origin,
        destination,
        midPoints,
        lineColor,
        lineWidth,
        paths
      );
    }
    return {status: 0, message: "", result: param};
  }
  public async showRouteLine(
    id: string,
    origin: number[],
    destination: number[],
    midPoints: number[][],
    lineColor: string,
    lineWidth: Number,
    paths: number[][]
  ) {
    //添加起点终点
    let overlays: any[] = [];
    overlays.push({
      id: id,
      geometry: {x: origin[0], y: origin[1]},
      symbol: {
        type: "point",
        url: "static/styles/img/start.png",
        size: [39, 45],
        xoffset: 0,
        yoffset: -21
      },
      fields: {}
    });

    if (midPoints && midPoints.length) {
      midPoints.forEach((midPt: number[]) => {
        overlays.push({
          id: id,
          geometry: {x: midPt[0], y: midPt[1]},
          symbol: {
            type: "point",
            url: require("@/assets/images/mid.png"),
            size: [23, 37],
            xoffset: 0,
            yoffset: -19
          },
          fields: {}
        });
      }, this);
    }
    overlays.push({
      id: id,
      geometry: {x: destination[0], y: destination[1]},
      symbol: {
        type: "point",
        url: "static/styles/img/end.png",
        size: [39, 45],
        xoffset: 0,
        yoffset: -21
      },
      fields: {}
    });
    overlays.push({
      id: id,
      geometry: {paths: paths},
      symbol: {
        type: "polyline",
        color: lineColor,
        width: lineWidth
      }
    });
    let datajson = {
      type: "routesearchPgis",
      defaultSymbol: {
        type: "point",
        url: "static/styles/img/start.png",
        size: [39, 45],
        xoffset: 0,
        yoffset: -21
      },
      transform: "BD9ToWGS84",
      overlays: overlays,
      centerResult: true
    };
    let overlay = OverlayPGIS.getInstance(this.view, this.fmap);
    await overlay.addOverlays(datajson);
  }
}
